//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import * as api from '~/api/index';
import * as memberApi from '~/api/member';

export default {
  name: 'Home',
  async asyncData({ error, store, $axios }) {
    try {
      const [
        tagListResult,
        swipersResult,
        homeSquareResult,
        commandListResult,
        memberTagsResult,
      ] = await Promise.all([
        $axios(memberApi.getIndexTab()),
        $axios(api.getSwiperArticle()),
        $axios(api.getHomeSquareArticle()),
        $axios(api.getCommandList({ page: 1, count: 8 })),
        $axios(
          memberApi.getSvipTab({
            channel: 'websvip',
          })
        ),
      ]);
      let tagList = tagListResult?.result ?? [];
      const swipers = swipersResult?.result ?? [];
      const commandList = commandListResult?.result ?? [];
      let memberTags = memberTagsResult?.result ?? [];
      const homeSquare = homeSquareResult?.result ?? [];
      tagList = tagList?.['web_home']?.children ?? [];
      tagList = tagList
        .filter(item => item.id !== 'web_home_page')
        .map(item => {
          return {
            value: item.id,
            name: item.name,
          };
        });
      if (memberTags) {
        memberTags = memberTags
          .map(item => {
            return {
              equityId: item.id,
              title: item.name,
            };
          })
          .filter(
            item => item.equityId !== 'assembly' && item.equityId !== 'all'
          );
      }
      const indexSwipers =
        (store.state.advertisement && store.state.advertisement.indexSwipers) ||
        [];
      swipers.unshift(...indexSwipers);
      return {
        nomore: false,
        swiperLeft: swipers,
        swiperRight: homeSquare || [],
        tags: tagList,
        commandList: commandList ? commandList : [],
        membertag: memberTags ? memberTags : [],
      };
    } catch (err) {
      console.warn(err);
      error({
        statusCode: 404,
        message: {
          title: '很抱歉您访问的页面出错了！',
          desc:
            '可能原因：1、系统繁忙；2、网络链接失败；3、找不到请求页面；' +
            `4、asyncData ${err.message}`,
        },
      });
    }
  },
  data() {
    return {
      page: 1,
      count: 30,
      freeLength: 0,
    };
  },
  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: 'https://www.gelonghui.com/',
        },
        {
          rel: 'alternate',
          media: 'only screen and (max-width:640px)',
          href: 'https://m.gelonghui.com/',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'userId']),
    ...mapState(['advertisement']),
    /**
     * @description 导航栏节日背景
     */
    adNavBg() {
      return (this.advertisement && this.advertisement.adNavBg) || null;
    },
    /**
     * @description 背景色
     */
    baseStyle() {
      let obj = null;
      if (this.adNavBg) {
        obj = {
          background: this.adNavBg.backgroundColor,
        };
      }
      return obj;
    },
  },
};
